import { tremorTwMerge } from "@app/componentLibrary/lib/tremorTwMerge";
import React from "react";

export const NightIcon = (props: React.HTMLAttributes<SVGSVGElement>) => (
    <svg
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={tremorTwMerge("inline-block fill-gray-500", props.className)}
    >
        <g>
            <path
                id="bedtime"
                d="M16.3128 15.8957C15.5489 16.7985 14.6219 17.5138 13.5316 18.0415C12.4413 18.5693 11.2642 18.8332 10.0003 18.8332C8.84755 18.8332 7.76421 18.6144 6.75033 18.1769C5.73644 17.7394 4.85449 17.1457 4.10449 16.3957C3.35449 15.6457 2.76074 14.7638 2.32324 13.7499C1.88574 12.736 1.66699 11.6526 1.66699 10.4999C1.66699 8.4582 2.30935 6.65959 3.59408 5.10403C4.8788 3.54848 6.59755 2.60403 8.75033 2.2707C9.1531 2.20125 9.4413 2.295 9.61491 2.55195C9.78852 2.80889 9.79894 3.1457 9.64616 3.56236C9.22949 4.72903 9.08366 5.90612 9.20866 7.09362C9.33366 8.28112 9.67394 9.37487 10.2295 10.3749C10.785 11.3749 11.5316 12.2394 12.4691 12.9686C13.4066 13.6978 14.4795 14.1943 15.6878 14.4582C16.1323 14.5554 16.4135 14.7429 16.5316 15.0207C16.6496 15.2985 16.5767 15.5901 16.3128 15.8957Z"
                fill="fillColor"
            />
        </g>
    </svg>
);
